import * as ActionTypes from './actions';
import * as AuthActionTypes from '../auth/actions';
import * as ChildrenActionTypes from './children/actions';
import update from 'immutability-helper';
import globalize from '../common/services/globalize';

const initialState = {
	id: 0,
	children: [],
	childrenGrades: {},
	centerId: 0,
	city: '',
	firstName: '',
	lastName: '',
	fullName: ''
};

const parent = (state = initialState, action) => {
	let childIndex;
	switch (action.type) {
		case AuthActionTypes.LOGOUT:
			return initialState;
		case ActionTypes.PARENT_FETCH_SUCCESS:
		case ActionTypes.PROFILE_UPDATE_SUCCESS:
			return update(state, { $merge: action.response });
		case ActionTypes.CHILD_CREATE_SUCCESS:
			return update(state, {
				children: { $push: [action.response] },
				childrenGrades: { $set: {} }	// age appropriate grades will be reloaded to include the new child
			});
		case ActionTypes.CHILD_UPDATE_SUCCESS:
			childIndex = getChildIndex(state, action.response.id);
			return update(state, {
				children: {
					[childIndex]: { $set: action.response }
				},
				childrenGrades: { $set: {} }
			});
		case ChildrenActionTypes.MEDICAL_INFORMATION_UPDATE_SUCCESS:
			childIndex = getChildIndex(state, action.response.result);	// normalized response as per medicalInformationSchema
			return update(state, {
				children: {
					[childIndex]: { $merge: { hasMedicalInformation: true } }
				}
			});
		case ActionTypes.CHILD_DELETE_SUCCESS:
			childIndex = getChildIndex(state, action.response.id);
			return update(state, {
				children: { $splice: [[childIndex, 1]] }
			});
		case ActionTypes.CENTER_UPDATE_SUCCESS:
			return update(state, {
				centerId: { $set: action.response.centerId },
				city: { $set: action.response.city }
			});
		case ActionTypes.CHILDREN_GRADES_SUCCESS:
			return update(state, {
				childrenGrades: {
					[`${action.centerId}:${action.termId}`]: { $set: action.response }
				}
			});
		default:
			return state;
	}
};

export default parent;

export const getChild = (parent, id) => parent.children.find(c => c.id === Number(id));
export const getChildIndex = (parent, id) => parent.children.findIndex(c => c.id === Number(id));
export const hasSameAsParentChild = (parent) => parent.children.find(c => c.sameAsParent) != undefined;